import React, { useState } from "react";
import TabContent from "../components/TabContent";
import GetTab from "../components/GetTab";

function GetTabs() {
  const [activeTab, setActiveTab] = useState("tab1");
  return (
    <div className="relative grid place-items-center">
      <TabContent id="tab1" activeTab={activeTab}>
        <img
          src={require("../assets/images/bg/mindsdb.webp")}
          className="rounded-lg"
          loading="lazy"
          width={1367}
          height={859}
          alt="pic"
        />
      </TabContent>
      <TabContent id="tab2" activeTab={activeTab}>
        <img
          src={require("../assets/images/bg/flatfile.webp")}
          className="rounded-lg"
          loading="lazy"
          width={1367}
          height={859}
          alt="pic"
        />
      </TabContent>
      <TabContent id="tab3" activeTab={activeTab}>
        <img
          src={require("../assets/images/bg/dynamic.webp")}
          className="rounded-lg"
          loading="lazy"
          width={1367}
          height={859}
          alt="pic"
        />
      </TabContent>
      <TabContent id="tab4" activeTab={activeTab}>
        <img
          src={require("../assets/images/bg/whop.webp")}
          className="rounded-lg"
          loading="lazy"
          width={1367}
          height={859}
          alt="pic"
        />
      </TabContent>
      <TabContent id="tab5" activeTab={activeTab}>
        <img
          src={require("../assets/images/bg/mage.webp")}
          className="rounded-lg"
          loading="lazy"
          width={1367}
          height={859}
          alt="pic"
        />
      </TabContent>
      <TabContent id="tab6" activeTab={activeTab}>
        <img
          src={require("../assets/images/bg/plane.webp")}
          className="rounded-lg"
          loading="lazy"
          width={1367}
          height={859}
          alt="pic"
        />
      </TabContent>
      <div className="absolute rounded-lg z-30 bottom-0 flex items-end justify-center w-full h-1/2 md:h-[25rem] bg-gradient-to-b from-transparent to-black"></div>
      <div className="text-white h-16 absolute bottom-0 w-full flex gap-4 items-center justify-center z-40">
        <p className="hidden lg:block mr-4">Powered by Mintlify</p>
        <GetTab
          title="MindsDB"
          id="tab1"
          icon={require("../assets/images/mindsdb.png")}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <GetTab
          title="FlatFile"
          id="tab2"
          icon={require("../assets/images/flatfile.png")}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <GetTab
          title="Dynamic"
          id="tab3"
          icon={require("../assets/images/dynamic.png")}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <GetTab
          title="Whop"
          id="tab4"
          icon={require("../assets/images/whop.png")}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <GetTab
          title="Mage"
          id="tab5"
          icon={require("../assets/images/mage.png")}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <GetTab
          title="Plane"
          id="tab6"
          icon={require("../assets/images/plane.png")}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        {/* <div className="flex items-center gap-2 cursor-pointer bg-white/40 p-1 rounded-full">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_254_1757)">
              <path d="M20 0H0V20H20V0Z" fill="#00A587" />
              <path
                d="M12.5713 10.0317C12.7125 11.1461 12.8436 12.1923 12.9796 13.2375C12.9957 13.3627 12.9699 13.4068 12.8305 13.4139C11.991 13.4558 11.9915 13.4592 11.6879 12.6903C11.5616 12.3703 11.4385 12.0491 11.3039 11.7323C11.2743 11.6803 11.2633 11.6198 11.2729 11.5609C11.2824 11.5019 11.3119 11.4478 11.3564 11.4075C11.7536 10.9711 12.1404 10.5229 12.5713 10.0317Z"
                fill="white"
              />
              <path
                d="M7.6176 10.9524C7.73795 11.5613 7.85668 12.1336 7.96115 12.7085C7.99344 12.8864 8.13858 13.1125 8.01442 13.2327C7.90731 13.3362 7.66957 13.1899 7.4868 13.1965C7.00128 13.2146 6.77528 12.9907 6.69642 12.5207C6.65011 12.2447 6.62963 12.0536 6.86141 11.8399C7.13198 11.5598 7.38455 11.2633 7.6176 10.9524Z"
                fill="white"
              />
              <path
                d="M8.99959 12.0673C8.99959 11.7224 8.99426 11.3776 9.00216 11.0329C9.00524 10.8975 8.96705 10.8518 8.82134 10.847C7.82718 10.8146 6.83321 10.7752 5.83946 10.7289C5.6834 10.7217 5.62178 10.7654 5.58861 10.9178C5.43527 11.6231 5.26124 12.3243 5.11146 13.0305C5.06943 13.2287 4.99277 13.3019 4.78267 13.2793C4.54953 13.2555 4.31486 13.2502 4.08086 13.2634C3.90458 13.2722 3.87061 13.1995 3.87318 13.048C3.88838 11.9889 3.91086 10.9297 3.90051 9.8709C3.89861 9.54506 4.00886 9.22827 4.21318 8.97236C4.76308 8.21798 5.2928 7.45004 5.82556 6.68401C5.85429 6.63157 5.89953 6.58976 5.95442 6.56487C6.00934 6.54001 6.07092 6.53341 6.12997 6.54608C8.11645 6.75585 10.1038 6.95912 12.0918 7.15579C12.2161 7.17052 12.3348 7.21531 12.4374 7.28623C13.6204 8.04509 14.8012 8.80665 15.9902 9.5562C16.1681 9.66798 16.173 9.73182 16.002 9.8329C15.9652 9.85252 15.9323 9.87858 15.905 9.90985C15.5625 10.3465 15.161 10.3269 14.6758 10.1333C14.0892 9.90011 13.4708 9.74541 12.8694 9.54712C12.8122 9.5242 12.7501 9.51554 12.6887 9.52185C12.6272 9.52817 12.5684 9.54928 12.5171 9.58335C11.964 9.92246 11.4083 10.2574 10.8501 10.5882C10.7998 10.6148 10.7568 10.6531 10.725 10.6998C10.6931 10.7465 10.6732 10.8001 10.6671 10.8561C10.5447 11.5841 10.4046 12.309 10.2921 13.0389C10.2597 13.248 10.1842 13.3143 9.97359 13.2998C9.70613 13.2842 9.43804 13.2838 9.17054 13.2985C9.01188 13.3055 8.97127 13.2506 8.97648 13.1013C8.9868 12.7566 8.97969 12.4115 8.97969 12.0666L8.99959 12.0673Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_254_1757">
                <rect width="20" height="20" rx="10" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p className="text-sm tracking-wide">MindsDB</p>
        </div>
        <div className="flex items-center gap-2 cursor-pointer">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_254_1757)">
              <path d="M20 0H0V20H20V0Z" fill="#00A587" />
              <path
                d="M12.5713 10.0317C12.7125 11.1461 12.8436 12.1923 12.9796 13.2375C12.9957 13.3627 12.9699 13.4068 12.8305 13.4139C11.991 13.4558 11.9915 13.4592 11.6879 12.6903C11.5616 12.3703 11.4385 12.0491 11.3039 11.7323C11.2743 11.6803 11.2633 11.6198 11.2729 11.5609C11.2824 11.5019 11.3119 11.4478 11.3564 11.4075C11.7536 10.9711 12.1404 10.5229 12.5713 10.0317Z"
                fill="white"
              />
              <path
                d="M7.6176 10.9524C7.73795 11.5613 7.85668 12.1336 7.96115 12.7085C7.99344 12.8864 8.13858 13.1125 8.01442 13.2327C7.90731 13.3362 7.66957 13.1899 7.4868 13.1965C7.00128 13.2146 6.77528 12.9907 6.69642 12.5207C6.65011 12.2447 6.62963 12.0536 6.86141 11.8399C7.13198 11.5598 7.38455 11.2633 7.6176 10.9524Z"
                fill="white"
              />
              <path
                d="M8.99959 12.0673C8.99959 11.7224 8.99426 11.3776 9.00216 11.0329C9.00524 10.8975 8.96705 10.8518 8.82134 10.847C7.82718 10.8146 6.83321 10.7752 5.83946 10.7289C5.6834 10.7217 5.62178 10.7654 5.58861 10.9178C5.43527 11.6231 5.26124 12.3243 5.11146 13.0305C5.06943 13.2287 4.99277 13.3019 4.78267 13.2793C4.54953 13.2555 4.31486 13.2502 4.08086 13.2634C3.90458 13.2722 3.87061 13.1995 3.87318 13.048C3.88838 11.9889 3.91086 10.9297 3.90051 9.8709C3.89861 9.54506 4.00886 9.22827 4.21318 8.97236C4.76308 8.21798 5.2928 7.45004 5.82556 6.68401C5.85429 6.63157 5.89953 6.58976 5.95442 6.56487C6.00934 6.54001 6.07092 6.53341 6.12997 6.54608C8.11645 6.75585 10.1038 6.95912 12.0918 7.15579C12.2161 7.17052 12.3348 7.21531 12.4374 7.28623C13.6204 8.04509 14.8012 8.80665 15.9902 9.5562C16.1681 9.66798 16.173 9.73182 16.002 9.8329C15.9652 9.85252 15.9323 9.87858 15.905 9.90985C15.5625 10.3465 15.161 10.3269 14.6758 10.1333C14.0892 9.90011 13.4708 9.74541 12.8694 9.54712C12.8122 9.5242 12.7501 9.51554 12.6887 9.52185C12.6272 9.52817 12.5684 9.54928 12.5171 9.58335C11.964 9.92246 11.4083 10.2574 10.8501 10.5882C10.7998 10.6148 10.7568 10.6531 10.725 10.6998C10.6931 10.7465 10.6732 10.8001 10.6671 10.8561C10.5447 11.5841 10.4046 12.309 10.2921 13.0389C10.2597 13.248 10.1842 13.3143 9.97359 13.2998C9.70613 13.2842 9.43804 13.2838 9.17054 13.2985C9.01188 13.3055 8.97127 13.2506 8.97648 13.1013C8.9868 12.7566 8.97969 12.4115 8.97969 12.0666L8.99959 12.0673Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_254_1757">
                <rect width="20" height="20" rx="10" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p className="text-sm tracking-wide">FlatFile</p>
        </div>
        <div className="flex items-center gap-2 cursor-pointer">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_254_1757)">
              <path d="M20 0H0V20H20V0Z" fill="#00A587" />
              <path
                d="M12.5713 10.0317C12.7125 11.1461 12.8436 12.1923 12.9796 13.2375C12.9957 13.3627 12.9699 13.4068 12.8305 13.4139C11.991 13.4558 11.9915 13.4592 11.6879 12.6903C11.5616 12.3703 11.4385 12.0491 11.3039 11.7323C11.2743 11.6803 11.2633 11.6198 11.2729 11.5609C11.2824 11.5019 11.3119 11.4478 11.3564 11.4075C11.7536 10.9711 12.1404 10.5229 12.5713 10.0317Z"
                fill="white"
              />
              <path
                d="M7.6176 10.9524C7.73795 11.5613 7.85668 12.1336 7.96115 12.7085C7.99344 12.8864 8.13858 13.1125 8.01442 13.2327C7.90731 13.3362 7.66957 13.1899 7.4868 13.1965C7.00128 13.2146 6.77528 12.9907 6.69642 12.5207C6.65011 12.2447 6.62963 12.0536 6.86141 11.8399C7.13198 11.5598 7.38455 11.2633 7.6176 10.9524Z"
                fill="white"
              />
              <path
                d="M8.99959 12.0673C8.99959 11.7224 8.99426 11.3776 9.00216 11.0329C9.00524 10.8975 8.96705 10.8518 8.82134 10.847C7.82718 10.8146 6.83321 10.7752 5.83946 10.7289C5.6834 10.7217 5.62178 10.7654 5.58861 10.9178C5.43527 11.6231 5.26124 12.3243 5.11146 13.0305C5.06943 13.2287 4.99277 13.3019 4.78267 13.2793C4.54953 13.2555 4.31486 13.2502 4.08086 13.2634C3.90458 13.2722 3.87061 13.1995 3.87318 13.048C3.88838 11.9889 3.91086 10.9297 3.90051 9.8709C3.89861 9.54506 4.00886 9.22827 4.21318 8.97236C4.76308 8.21798 5.2928 7.45004 5.82556 6.68401C5.85429 6.63157 5.89953 6.58976 5.95442 6.56487C6.00934 6.54001 6.07092 6.53341 6.12997 6.54608C8.11645 6.75585 10.1038 6.95912 12.0918 7.15579C12.2161 7.17052 12.3348 7.21531 12.4374 7.28623C13.6204 8.04509 14.8012 8.80665 15.9902 9.5562C16.1681 9.66798 16.173 9.73182 16.002 9.8329C15.9652 9.85252 15.9323 9.87858 15.905 9.90985C15.5625 10.3465 15.161 10.3269 14.6758 10.1333C14.0892 9.90011 13.4708 9.74541 12.8694 9.54712C12.8122 9.5242 12.7501 9.51554 12.6887 9.52185C12.6272 9.52817 12.5684 9.54928 12.5171 9.58335C11.964 9.92246 11.4083 10.2574 10.8501 10.5882C10.7998 10.6148 10.7568 10.6531 10.725 10.6998C10.6931 10.7465 10.6732 10.8001 10.6671 10.8561C10.5447 11.5841 10.4046 12.309 10.2921 13.0389C10.2597 13.248 10.1842 13.3143 9.97359 13.2998C9.70613 13.2842 9.43804 13.2838 9.17054 13.2985C9.01188 13.3055 8.97127 13.2506 8.97648 13.1013C8.9868 12.7566 8.97969 12.4115 8.97969 12.0666L8.99959 12.0673Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_254_1757">
                <rect width="20" height="20" rx="10" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p className="text-sm tracking-wide">Dynamic</p>
        </div>
        <div className="flex items-center gap-2 cursor-pointer">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_254_1757)">
              <path d="M20 0H0V20H20V0Z" fill="#00A587" />
              <path
                d="M12.5713 10.0317C12.7125 11.1461 12.8436 12.1923 12.9796 13.2375C12.9957 13.3627 12.9699 13.4068 12.8305 13.4139C11.991 13.4558 11.9915 13.4592 11.6879 12.6903C11.5616 12.3703 11.4385 12.0491 11.3039 11.7323C11.2743 11.6803 11.2633 11.6198 11.2729 11.5609C11.2824 11.5019 11.3119 11.4478 11.3564 11.4075C11.7536 10.9711 12.1404 10.5229 12.5713 10.0317Z"
                fill="white"
              />
              <path
                d="M7.6176 10.9524C7.73795 11.5613 7.85668 12.1336 7.96115 12.7085C7.99344 12.8864 8.13858 13.1125 8.01442 13.2327C7.90731 13.3362 7.66957 13.1899 7.4868 13.1965C7.00128 13.2146 6.77528 12.9907 6.69642 12.5207C6.65011 12.2447 6.62963 12.0536 6.86141 11.8399C7.13198 11.5598 7.38455 11.2633 7.6176 10.9524Z"
                fill="white"
              />
              <path
                d="M8.99959 12.0673C8.99959 11.7224 8.99426 11.3776 9.00216 11.0329C9.00524 10.8975 8.96705 10.8518 8.82134 10.847C7.82718 10.8146 6.83321 10.7752 5.83946 10.7289C5.6834 10.7217 5.62178 10.7654 5.58861 10.9178C5.43527 11.6231 5.26124 12.3243 5.11146 13.0305C5.06943 13.2287 4.99277 13.3019 4.78267 13.2793C4.54953 13.2555 4.31486 13.2502 4.08086 13.2634C3.90458 13.2722 3.87061 13.1995 3.87318 13.048C3.88838 11.9889 3.91086 10.9297 3.90051 9.8709C3.89861 9.54506 4.00886 9.22827 4.21318 8.97236C4.76308 8.21798 5.2928 7.45004 5.82556 6.68401C5.85429 6.63157 5.89953 6.58976 5.95442 6.56487C6.00934 6.54001 6.07092 6.53341 6.12997 6.54608C8.11645 6.75585 10.1038 6.95912 12.0918 7.15579C12.2161 7.17052 12.3348 7.21531 12.4374 7.28623C13.6204 8.04509 14.8012 8.80665 15.9902 9.5562C16.1681 9.66798 16.173 9.73182 16.002 9.8329C15.9652 9.85252 15.9323 9.87858 15.905 9.90985C15.5625 10.3465 15.161 10.3269 14.6758 10.1333C14.0892 9.90011 13.4708 9.74541 12.8694 9.54712C12.8122 9.5242 12.7501 9.51554 12.6887 9.52185C12.6272 9.52817 12.5684 9.54928 12.5171 9.58335C11.964 9.92246 11.4083 10.2574 10.8501 10.5882C10.7998 10.6148 10.7568 10.6531 10.725 10.6998C10.6931 10.7465 10.6732 10.8001 10.6671 10.8561C10.5447 11.5841 10.4046 12.309 10.2921 13.0389C10.2597 13.248 10.1842 13.3143 9.97359 13.2998C9.70613 13.2842 9.43804 13.2838 9.17054 13.2985C9.01188 13.3055 8.97127 13.2506 8.97648 13.1013C8.9868 12.7566 8.97969 12.4115 8.97969 12.0666L8.99959 12.0673Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_254_1757">
                <rect width="20" height="20" rx="10" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p className="text-sm tracking-wide">Whop</p>
        </div>
        <div className="flex items-center gap-2 cursor-pointer">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_254_1757)">
              <path d="M20 0H0V20H20V0Z" fill="#00A587" />
              <path
                d="M12.5713 10.0317C12.7125 11.1461 12.8436 12.1923 12.9796 13.2375C12.9957 13.3627 12.9699 13.4068 12.8305 13.4139C11.991 13.4558 11.9915 13.4592 11.6879 12.6903C11.5616 12.3703 11.4385 12.0491 11.3039 11.7323C11.2743 11.6803 11.2633 11.6198 11.2729 11.5609C11.2824 11.5019 11.3119 11.4478 11.3564 11.4075C11.7536 10.9711 12.1404 10.5229 12.5713 10.0317Z"
                fill="white"
              />
              <path
                d="M7.6176 10.9524C7.73795 11.5613 7.85668 12.1336 7.96115 12.7085C7.99344 12.8864 8.13858 13.1125 8.01442 13.2327C7.90731 13.3362 7.66957 13.1899 7.4868 13.1965C7.00128 13.2146 6.77528 12.9907 6.69642 12.5207C6.65011 12.2447 6.62963 12.0536 6.86141 11.8399C7.13198 11.5598 7.38455 11.2633 7.6176 10.9524Z"
                fill="white"
              />
              <path
                d="M8.99959 12.0673C8.99959 11.7224 8.99426 11.3776 9.00216 11.0329C9.00524 10.8975 8.96705 10.8518 8.82134 10.847C7.82718 10.8146 6.83321 10.7752 5.83946 10.7289C5.6834 10.7217 5.62178 10.7654 5.58861 10.9178C5.43527 11.6231 5.26124 12.3243 5.11146 13.0305C5.06943 13.2287 4.99277 13.3019 4.78267 13.2793C4.54953 13.2555 4.31486 13.2502 4.08086 13.2634C3.90458 13.2722 3.87061 13.1995 3.87318 13.048C3.88838 11.9889 3.91086 10.9297 3.90051 9.8709C3.89861 9.54506 4.00886 9.22827 4.21318 8.97236C4.76308 8.21798 5.2928 7.45004 5.82556 6.68401C5.85429 6.63157 5.89953 6.58976 5.95442 6.56487C6.00934 6.54001 6.07092 6.53341 6.12997 6.54608C8.11645 6.75585 10.1038 6.95912 12.0918 7.15579C12.2161 7.17052 12.3348 7.21531 12.4374 7.28623C13.6204 8.04509 14.8012 8.80665 15.9902 9.5562C16.1681 9.66798 16.173 9.73182 16.002 9.8329C15.9652 9.85252 15.9323 9.87858 15.905 9.90985C15.5625 10.3465 15.161 10.3269 14.6758 10.1333C14.0892 9.90011 13.4708 9.74541 12.8694 9.54712C12.8122 9.5242 12.7501 9.51554 12.6887 9.52185C12.6272 9.52817 12.5684 9.54928 12.5171 9.58335C11.964 9.92246 11.4083 10.2574 10.8501 10.5882C10.7998 10.6148 10.7568 10.6531 10.725 10.6998C10.6931 10.7465 10.6732 10.8001 10.6671 10.8561C10.5447 11.5841 10.4046 12.309 10.2921 13.0389C10.2597 13.248 10.1842 13.3143 9.97359 13.2998C9.70613 13.2842 9.43804 13.2838 9.17054 13.2985C9.01188 13.3055 8.97127 13.2506 8.97648 13.1013C8.9868 12.7566 8.97969 12.4115 8.97969 12.0666L8.99959 12.0673Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_254_1757">
                <rect width="20" height="20" rx="10" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p className="text-sm tracking-wide">Mage</p>
        </div>
        <div className="flex items-center gap-2 cursor-pointer">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_254_1757)">
              <path d="M20 0H0V20H20V0Z" fill="#00A587" />
              <path
                d="M12.5713 10.0317C12.7125 11.1461 12.8436 12.1923 12.9796 13.2375C12.9957 13.3627 12.9699 13.4068 12.8305 13.4139C11.991 13.4558 11.9915 13.4592 11.6879 12.6903C11.5616 12.3703 11.4385 12.0491 11.3039 11.7323C11.2743 11.6803 11.2633 11.6198 11.2729 11.5609C11.2824 11.5019 11.3119 11.4478 11.3564 11.4075C11.7536 10.9711 12.1404 10.5229 12.5713 10.0317Z"
                fill="white"
              />
              <path
                d="M7.6176 10.9524C7.73795 11.5613 7.85668 12.1336 7.96115 12.7085C7.99344 12.8864 8.13858 13.1125 8.01442 13.2327C7.90731 13.3362 7.66957 13.1899 7.4868 13.1965C7.00128 13.2146 6.77528 12.9907 6.69642 12.5207C6.65011 12.2447 6.62963 12.0536 6.86141 11.8399C7.13198 11.5598 7.38455 11.2633 7.6176 10.9524Z"
                fill="white"
              />
              <path
                d="M8.99959 12.0673C8.99959 11.7224 8.99426 11.3776 9.00216 11.0329C9.00524 10.8975 8.96705 10.8518 8.82134 10.847C7.82718 10.8146 6.83321 10.7752 5.83946 10.7289C5.6834 10.7217 5.62178 10.7654 5.58861 10.9178C5.43527 11.6231 5.26124 12.3243 5.11146 13.0305C5.06943 13.2287 4.99277 13.3019 4.78267 13.2793C4.54953 13.2555 4.31486 13.2502 4.08086 13.2634C3.90458 13.2722 3.87061 13.1995 3.87318 13.048C3.88838 11.9889 3.91086 10.9297 3.90051 9.8709C3.89861 9.54506 4.00886 9.22827 4.21318 8.97236C4.76308 8.21798 5.2928 7.45004 5.82556 6.68401C5.85429 6.63157 5.89953 6.58976 5.95442 6.56487C6.00934 6.54001 6.07092 6.53341 6.12997 6.54608C8.11645 6.75585 10.1038 6.95912 12.0918 7.15579C12.2161 7.17052 12.3348 7.21531 12.4374 7.28623C13.6204 8.04509 14.8012 8.80665 15.9902 9.5562C16.1681 9.66798 16.173 9.73182 16.002 9.8329C15.9652 9.85252 15.9323 9.87858 15.905 9.90985C15.5625 10.3465 15.161 10.3269 14.6758 10.1333C14.0892 9.90011 13.4708 9.74541 12.8694 9.54712C12.8122 9.5242 12.7501 9.51554 12.6887 9.52185C12.6272 9.52817 12.5684 9.54928 12.5171 9.58335C11.964 9.92246 11.4083 10.2574 10.8501 10.5882C10.7998 10.6148 10.7568 10.6531 10.725 10.6998C10.6931 10.7465 10.6732 10.8001 10.6671 10.8561C10.5447 11.5841 10.4046 12.309 10.2921 13.0389C10.2597 13.248 10.1842 13.3143 9.97359 13.2998C9.70613 13.2842 9.43804 13.2838 9.17054 13.2985C9.01188 13.3055 8.97127 13.2506 8.97648 13.1013C8.9868 12.7566 8.97969 12.4115 8.97969 12.0666L8.99959 12.0673Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_254_1757">
                <rect width="20" height="20" rx="10" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p className="text-sm tracking-wide">Plane</p>
        </div> */}
      </div>
    </div>
  );
}

export default GetTabs;
